import { type ComponentType, type ReactNode } from 'react';

import styles from './customizationPanel.module.scss';

interface ISearchRowProps {
  input: ReactNode,
  resetKey: string | number,
  showDateFilter?: boolean,
  DateFilter?: ComponentType,
}

export const SearchRow = ({ input, resetKey, showDateFilter = false, DateFilter }: ISearchRowProps) => (
  <div className={ styles.searchRow }>
    <div className={ styles.searchField }>{ input }</div>
    { showDateFilter && DateFilter && (
      <div className={ styles.dateFilterField }>
        <DateFilter key={ resetKey } />
      </div>
    ) }
  </div>
);
